import React, { useState, useContext } from "react";
import {
    UiAuthContainer,
    UiAuthFooterContainer,
} from "../../_uiComponents/common/custom/header/UiTopNavElements";

import ForgotPassword from "../auth/forms/ForgotPassword";
import { participantUrl } from "../../../_redux/_constants";

export default function ForgotPasswordWrapper(props) {
    const hostname = window.location.hostname
        .replace(".com", "")
        .split(".")
        .pop();
    const isTlc = hostname === participantUrl.RENAULT_TLC_URL;
    return (
        <>
            <UiAuthContainer>
                <div className={isTlc ? "sb-auth-top-wr sb-auth-top-wr-top-tlc sb-auth-forgot-pwd" : "sb-auth-top-wr sb-auth-top-wr-top sb-auth-forgot-pwd"}>
                    <h2>Forgot Password</h2>
                    <div className="sba-auth-top-heading">
                        <h5>Please enter your registered email address</h5>
                    </div>
                    <ForgotPassword />
                    <UiAuthFooterContainer />
                </div>
            </UiAuthContainer>
        </>
    );
}
